import { Map } from "@iventis/mapbox-gl";
import { FeatureCollection, Point } from "geojson";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { BehaviorSubject } from "rxjs";
import { iventisIconToAggregateLayer } from "../mapbox/engine-mapbox-helpers";
import { SupportedMapboxLayer } from "../mapbox/sublayer-types";
import { MapState } from "../../types/store-schema";
import { SplitLineIndicatorLayer } from "../generic-layers/split-line-indicator-layer";

/** Mapbox layer which shows the split indicator on a line map object */
export class MapboxSplitLineIndicatorLayer extends SplitLineIndicatorLayer {
    private readonly map: Map;

    private mapboxLayers: SupportedMapboxLayer[] = [];

    constructor(map: Map, state$: BehaviorSubject<MapState>) {
        super(state$);
        this.map = map;
        this.addLocalSource();
        this.addLayer();
    }

    protected addLayer() {
        this.mapboxLayers = iventisIconToAggregateLayer(
            this.splitLineIndicatorLayer,
            false,
            {},
            { projectDataFields: [], unitOfMeasurement: UnitOfMeasurement.Metric },
            null,
            null
        ).map((layer) => layer.layer);

        this.mapboxLayers.forEach((layer) => {
            this.map.addLayer(layer);
        });
    }

    public removeLayer() {
        this.mapboxLayers.forEach((layer) => {
            if (this.map.getLayer(layer.id)) {
                this.map.removeLayer(layer.id);
            }
        });
    }

    protected addLocalSource() {
        this.map.addSource(this.sourceId, { type: "geojson", data: this.source });
    }

    public removeLocalSource() {
        if (this.map.getSource(this.sourceId)) {
            this.map.removeSource(this.sourceId);
        }
    }

    public updateLocalSource(updatedPoint: FeatureCollection<Point>) {
        super.updateLocalSource(updatedPoint);
        const source = this.map.getSource(this.sourceId);
        if (source.type === "geojson") {
            source.setData(this.source);
        }
    }

    public getLayerIdsForSnapping(): string[] {
        throw new Error("Method not implemented.");
    }

    protected updateStyle(): void {
        throw new Error("Method not implemented.");
    }

    protected hideLayer(): void {
        throw new Error("Method not implemented.");
    }

    protected showLayer(): void {
        throw new Error("Method not implemented.");
    }

    protected updateMapOrder(): void {
        throw new Error("Method not implemented.");
    }

    protected updateMapLevel(): void {
        throw new Error("Method not implemented.");
    }

    public remove() {
        this.removeLayer();
        this.removeLocalSource();
    }
}
